import { PaymentApi } from '../../api/client';

export const addPaymentMethod = async (
  userId: string,
  tokenId: string,
  paymenMethodType = 'card',
  isDefault = false
) => {
  const client = PaymentApi();

  const result = await client.methodAddCreate({
    is_default: isDefault,
    payment_method_type: paymenMethodType,
    token_id: tokenId,
    user_id: userId,
  });

  return result;
};

export const removePaymentMethod = async (
  userId: string,
  paymentMethodId: string,
  tenant: string
) => {
  const client = PaymentApi();

  const result = await client.methodDeleteCreate({
    payment_method_id: paymentMethodId,
    user_id: userId,
    tenant,
  });

  return result;
};

export const setDefaultPaymentMethod = async (
  userId: string,
  paymentMethodId: string
) => {
  const client = PaymentApi();

  const result = await client.methodDefaultCreate({
    payment_method_id: paymentMethodId,
    user_id: userId,
  });

  return result;
};

export const getProducts = async (userId: string) => {
  const client = PaymentApi();

  const result = await client.productListUserIdList(userId);

  return result.data;
};

export const getPaymentMethods = async (userId: string) => {
  const client = PaymentApi();

  const result = await client.methodListUserIdList(userId);

  return result.data;
};

export const subscriptionUpgrade = async (
  userId: string,
  productId: string,
  paymentMethodId: string | undefined,
  productName: string
) => {
  const client = PaymentApi();

  const result = await client.subscriptionUpgradeCreate({
    payment_method_id: paymentMethodId,
    product_id: productId,
    product_name: productName,
    user_id: userId,
  });

  return result;
};

export const subscriptionDowngrade = async (
  userId: string,
  productId: string,
  paymentMethodId: string | undefined,
  productName: string
) => {
  const client = PaymentApi();

  const result = await client.subscriptionDowngradeCreate({
    payment_method_id: paymentMethodId,
    product_id: productId,
    product_name: productName,
    user_id: userId,
  });

  return result;
};

export const getBillingHistory = async (
  userId: string,
  query: {
    start_time: string;
    end_time: string;
  }
) => {
  const client = PaymentApi();

  const result = await client.historyListUserIdList(userId, query);

  return result.data;
};
